import isObject from 'lodash/isObject'

import React from 'react'
import clsx from 'clsx'

import { classToFComponent, type FCClassContext } from 'cube-react'

import { Container, BrLoading } from '@govbr-ds/react-components'

import Sel from './styles-consts'
import FiltroView from './filtro'
import ResumoView from './v-resumo'
import GradeView from './v-grade'

import './styles.scss'
import { AnaliseReacoesScope } from '../analise-reacoes.scope'

export type AnaliseReacoesProps = {
    className?: string
    scope: AnaliseReacoesScope
}

class AnaliseReacoesViewClass implements FCClassContext<AnaliseReacoesProps> {
    scope!: AnaliseReacoesScope

    render({ className, scope }: AnaliseReacoesProps) {
        this.scope = scope

        const gradeElm = scope.loading ? (
            <div className={Sel.mLg('10xh')}>
                <BrLoading large label='Buscando dados...'/>
            </div>
        ) : (
            <>
                {isObject(scope.resumo) && <ResumoView scope={scope.resumo} />}
                {isObject(scope.grade) && <GradeView scope={scope.grade} />}
            </>
        )

        return (
            <Container className={clsx(className)}>
                <div className={Sel.brCardHeader}>
                    <div className={Sel.dFlex}>
                        <div>
                            <div className={clsx(Sel.textWeightSemiBold, Sel.textUp02)}>
                                Monitoramento de Reações Adversas
                            </div>
                            <div>MedDRA • WHO Drug • Conferência de Bula Automatizada</div>
                        </div>
                    </div>
                </div>
                <br />
                <FiltroView scope={scope.filtro} />
                {gradeElm}
            </Container>
        )
    }
}

export default classToFComponent<AnaliseReacoesProps>(AnaliseReacoesViewClass)
